import React from 'react';
import Fade from 'react-reveal/Fade';
import Zoom from 'react-reveal/Zoom';
import diagramPath from '../../../assets/img/approach-diagram.png'
const HomeApproach = () => {
    return (
        <section className="section-c section-4">
            <div className="section-title">
                <h2>Approach</h2>
            </div>
            <div className="diagram-wrapper">
                <Fade top duration={1000}>
                    <div>
                        <h3>
                            User-centered design and development
                    </h3>
                        <p>
                            Both the design and the development of a digital product focus on the end user, taking into account their requirements, objectives
                        and feedback.
                        <br /> I always try to understand and deliver what the user
                        <em> really</em> needs, rather than what people
                        <em> assume</em> they want.
                    </p>
                    </div>
                </Fade>
                <Zoom duration={1000}>
                    <img className="animated" src={diagramPath} />
                </Zoom>

            </div>
        </section>
    )
};

export default HomeApproach;


// WEBPACK FOOTER //
// ./src/components/home/Approach/index.js